import { Api } from "./Api";
import axios from "axios";

export class MobileAppReleaseApi extends Api {
    constructor() {
        super("mobile_app/apk");
    }

    getAll(params?: Object): Promise<any> {
        return this.getResources(params).then(function (response) {
            return response.data;
        });
    }

    upload(file: File): Promise<any> {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(this.apiUrl, formData);
    }

    setDefault(id: number): Promise<any> {
        return axios.put(this.apiUrl + id + "/default", {});
    }

    delete(id: number): Promise<any> {
        return this.deleteResource(id);
    }
}
